/**
 * @flow
 * @relayHash 5d2a2d1a65657536e33ca0392db8a183
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FolderWrapperWrapperQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query FolderWrapperWrapperQuery(
  $userIds: [String]!
  $selectedItemIds: [String]!
  $shouldFillInFolder: Boolean!
) {
  viewer {
    ...FolderWrapperWrapper_viewer
    id
  }
}

fragment FolderWrapperWrapper_viewer on Viewer {
  id
  ...FolderWrapper_viewer
}

fragment FolderWrapper_viewer on Viewer {
  portfolioItemMatches(itemIds: $selectedItemIds, userIds: $userIds, portfolioTypes: [FOLDER]) @include(if: $shouldFillInFolder) {
    item {
      serviceId
      id
    }
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "selectedItemIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "shouldFillInFolder",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FolderWrapperWrapperQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FolderWrapperWrapper_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "FolderWrapperWrapperQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "selectedItemIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "shouldFillInFolder",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "FolderWrapperWrapperQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFillInFolder",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "itemIds",
                    "variableName": "selectedItemIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "FOLDER"
                    ],
                    "type": "[PortfolioTypes]"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds",
                    "type": "[String]"
                  }
                ],
                "concreteType": "PortfolioItemV2",
                "name": "portfolioItemMatches",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query FolderWrapperWrapperQuery(\n  $userIds: [String]!\n  $selectedItemIds: [String]!\n  $shouldFillInFolder: Boolean!\n) {\n  viewer {\n    ...FolderWrapperWrapper_viewer\n    id\n  }\n}\n\nfragment FolderWrapperWrapper_viewer on Viewer {\n  id\n  ...FolderWrapper_viewer\n}\n\nfragment FolderWrapper_viewer on Viewer {\n  portfolioItemMatches(itemIds: $selectedItemIds, userIds: $userIds, portfolioTypes: [FOLDER]) @include(if: $shouldFillInFolder) {\n    item {\n      serviceId\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/global/components/__generated__/FolderWrapperWrapperQuery.graphql.js